"use client";

import React from "react";
import { TypeAnimation } from "react-type-animation";

const typeAnimationSequence = [
  "Architects",
  1000,
  "",
  200,
  "Designers",
  1000,
  "",
  200,
  "Developers",
  1000,
  "",
  200,
  "Mathematicians",
  1000,
  "",
  200,
  "Everyone!",
  1000,
  "",
  200,
]

const InnovativeText = () => {
  return (
    <div className="innovative-text">
      An Innovative Tool for <TypeAnimation sequence={typeAnimationSequence} repeat={Infinity} className="intended-for-text" />
    </div>
  )
}

export default InnovativeText;
